<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">NCR Investigation</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">NCR Number</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.ncrNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Reported Date</label>
                <flat-pickr class="form-control" v-model="ncr.ncrDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Addressed To</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.memberName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Non Conformance Type Name</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="happened-before">Happened Before</label>
                <input type="checkbox" class="form-control" v-model="ncr.happenedBefore" id="happened-before" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="ncr.description" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
              <label for="action">Action</label>
              <select type = "dropdown" class="form-control" id="action" v-model="ncr.action">
                <option v-for="(list, index) in this.actionLists" :key="index" :value="list.value">{{ list.title }}</option>
              </select>
            </div>
            <div class="form-group col-6">
              <label for="comment">Comment</label>
              <textarea class="form-control" id="comment" v-model="ncr.comment" rows="3"></textarea>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ncrUser } from '../../models/ncrUser'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'


export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
            ncr: {...ncrUser},
            actionLists: [
                {
                    title: 'Valid',
                    value: 'valid'
                },
                {
                    title: 'Invalid',
                    value: 'invalid'
                },
                {
                    title: 'Feedback',
                    value: 'feedback'
                }
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ncrApi = api('ncr-investigation')
            this.ncr = await ncrApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const ncrApi = api('ncr-investigation')
            if(this.$route.query.id !== undefined) {
                await ncrApi.update(this.ncr, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            this.$router.push({ name: 'dashboard' })
        },
        finishLookup(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
        finishUpload(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
    }
}
</script>